import React from 'react';

import Modal from './Modal';
import Icon from 'components/commons/icon/Icon';
import { useRouting } from 'hooks/useRouting';
import * as api from 'config/api';
import { BrokerList } from './UpdateDateTimeModal';
import { isIosAppNotPremium } from '../utils/userStatus';

type CooperationStoppedModalProps = {
  hideModal: () => void;
  account?: string;
  brokers?: Array<api.GetUserBrokerResultItem>;
  currentPath?: string;
  isAuthenticatedMoneytree?: boolean | null;
  isLinkedMoneytree?: boolean | null;
};

const CooperationStoppedModal: React.FC<CooperationStoppedModalProps> = props => {
  const { hideModal, account, brokers, currentPath } = props;
  const routing = useRouting();
  function handleClickAccountDetail(): void {
    routing.pushRouting({ path: `/accountdetail/${account}` }, true);
  }
  function handleClickSecurityaccounts(): void {
    routing.pushRouting({ path: '/securityaccounts' }, true);
  }
  const isAccountDetail = currentPath?.startsWith('/accountdetail');

  return (
    <Modal onClose={hideModal}>
      <div className="max-h-modal overflow-y-auto">
        <div className="flex my-2 mx-3 p-2">
          {account ? (
            <div className="flex-grow text-left text-lg font-bold">
              口座が連携停止中です
            </div>
          ) : (
            <div className="flex-grow text-left text-lg font-bold">
              連携停止中の口座があります
            </div>
          )}
          <button
            onClick={e => {
              e.stopPropagation();
              hideModal();
            }}>
            <Icon name="close" className="text-2xl text-gray-500 text-center" />
          </button>
        </div>
        <div className="mx-3">
          <BrokerList
            brokers={brokers}
            isAuthenticatedMoneytree={props.isAuthenticatedMoneytree}
            isLinkedMoneytree={props.isLinkedMoneytree}
          />
        </div>
        <div className="m-3 text-sm">
          次のいずれかの理由に該当するため最新のデータを取得できませんでした。
          <br />
          <br />
          （１）接続先の金融機関がメンテナンス中
          <br />
          （２）接続先の金融機関のログインID/パスワードを変更、もしくはアカウントロックされている
          <br />
          （３）接続先の金融機関にお客様の確認が必要なメッセージがある
          <br />
          （４）一時的に接続しづらくなっている場合
          <br />
          <br />
          （２）（３）にお心当たりがある場合は接続先の金融機関にてご確認ください。
          {!isIosAppNotPremium() && (
            <>
              また、Moneytree連携の口座の場合、Moneytreeの画面にて更新が完了しているかご確認ください。
              それ以外の場合は次回の更新までお待ちください。
            </>
          )}
        </div>
        {!account ? (
          <div
            className="flex justify-center text-gray-500 m-1 p-2 cursor-pointer"
            onClick={e => {
              e.stopPropagation();
              handleClickSecurityaccounts();
            }}>
            連携口座一覧を確認
          </div>
        ) : account && !isAccountDetail ? (
          <div
            className="flex justify-center text-gray-500 m-1 p-2 cursor-pointer"
            onClick={e => {
              e.stopPropagation();
              handleClickAccountDetail();
            }}>
            口座詳細を確認
          </div>
        ) : (
          <></>
        )}
        <div
          className="flex justify-center text-gray-500 m-1 p-2 cursor-pointer"
          onClick={e => {
            e.stopPropagation();
            hideModal();
          }}>
          閉じる
        </div>
      </div>
    </Modal>
  );
};

export default CooperationStoppedModal;
